import { AddOnHoverPanel } from 'components/Panel/AddOnHoverPanel';
import { useTranslation } from 'react-i18next';
import { Project, Calculation } from 'types/domainTypes';
import { CalculationsView } from './CalculationsView';
import { ReactElement } from 'react';

interface ProjectCalculationsDetailsViewProps {
  onAddCalculationClick: () => void;
  onDeleteCalculationClick: (calculationId: string) => Promise<void>;
  onDuplicateCalculationClick: (calculation?: Calculation) => void;
  project: Project;
}

export function ProjectCalculationsDetailsView({
  onAddCalculationClick,
  onDeleteCalculationClick,
  onDuplicateCalculationClick,
  project,
}: ProjectCalculationsDetailsViewProps): ReactElement {
  const { t } = useTranslation();

  if (!project.calculations || project.calculations.length === 0) {
    return (
      <AddOnHoverPanel
        onClick={onAddCalculationClick}
        titleText={t('project-details-page.calculation-dialog.add-calculation-hover-title')}
        captionText={t('project-details-page.calculation-dialog.add-calculation-hover-caption')}
      />
    );
  }

  return (
    <CalculationsView
      project={project}
      onAddCalculations={onAddCalculationClick}
      onDeleteCalculation={onDeleteCalculationClick}
      onDuplicateCalculation={onDuplicateCalculationClick}
    />
  );
}
